"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
exports.default = (socketFactory$, listenEvents = []) => {
    const connectionStatus$ = new rxjs_1.BehaviorSubject({ status: false });
    const socketEvents$ = new rxjs_1.BehaviorSubject({ name: 'init' });
    const socket$ = socketFactory$.pipe((0, operators_1.switchMap)((socket) => new rxjs_1.Observable((observer) => {
        observer.next(socket);
        socketEvents$.next({ name: 'socket_init', extra: { socketId: socket.id } });
        let open = false;
        let forcedClose = false;
        const closed = (connectionEvent, reason) => {
            if (!open)
                return;
            connectionStatus$.next({ status: false, connectionEvent, reason });
            open = false;
        };
        socket.on('connect', () => {
            socketEvents$.next({ name: 'connect', extra: { socketId: socket.id } });
            open = true;
            connectionStatus$.next({ status: true, connectionEvent: 'connect' });
        });
        socket.on('error', (error) => {
            socketEvents$.next({ name: 'error', extra: { error, socketId: socket.id } });
            closed('error', error);
        });
        socket.on('disconnect', (reason) => {
            socketEvents$.next({ name: 'disconnect', extra: { reason, socketId: socket.id } });
            if (!open)
                return;
            closed(`disconnect`, reason);
            if (!forcedClose) {
                return;
            }
            observer.complete();
        });
        socket.on('connect_error', (error) => {
            socketEvents$.next({ name: 'connect_error', extra: { error, socketId: socket.id } });
        });
        socket.on('reconnect', (attempt) => {
            socketEvents$.next({ name: 'reconnect', extra: { attempt, socketId: socket.id } });
        });
        socket.on('reconnect_attempt', (attempt) => {
            socketEvents$.next({ name: 'reconnect_attempt', extra: { attempt, socketId: socket.id } });
        });
        socket.on('reconnect_error', (error) => {
            socketEvents$.next({ name: 'reconnect_error', extra: { error, socketId: socket.id } });
        });
        socket.on('reconnect_failed', () => {
            socketEvents$.next({ name: 'reconnect_failed', extra: { socketId: socket.id } });
        });
        return () => {
            forcedClose = true;
            if (open) {
                closed('disconnect', 'forcedClose');
                socket.close();
            }
        };
    })), (0, operators_1.publishReplay)(1), (0, operators_1.refCount)());
    const emit$ = socket$.pipe((0, operators_1.map)((socket) => ({ event, payload }) => new Promise((resolve, reject) => {
        socket.emit(event, payload, (ack) => {
            if (ack.error) {
                return reject(ack.error);
            }
            resolve(ack.success);
        });
    })));
    const messages$ = socket$.pipe((0, operators_1.mergeMap)((socket) => (0, rxjs_1.from)(listenEvents).pipe((0, operators_1.mergeMap)((event) => new rxjs_1.Observable((messages$) => {
        socket.on(event, (payload, ack) => {
            messages$.next({ event, payload });
            ack === null || ack === void 0 ? void 0 : ack();
        });
    })))));
    return { messages$, emit$, connectionStatus$, socketEvents$ };
};
